import React, { FC } from 'react';
import { Avatar } from '@mui/material';
import { EmptyAvatarVariantEnum } from '@sweatpals/shared';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';
import EmptyAvatar from './empty-avatar.component';
import { clsx } from '../../utils';

export interface UserAvatarProps {
	fullName: string;
	avatarSrc?: string;
	emptyAvatarVariant?: EmptyAvatarVariantEnum;
	sx?: SxProps<Theme>;
	emptyAvatarIconSize?: string;
}

export const UserAvatar: FC<UserAvatarProps> = ({
	fullName,
	avatarSrc,
	emptyAvatarVariant,
	emptyAvatarIconSize,
	sx,
}) => (
	<>
		{avatarSrc && <Avatar alt={fullName} src={avatarSrc} sx={clsx({ height: '32px', width: '32px' }, sx)} />}
		{!avatarSrc && emptyAvatarVariant && (
			<EmptyAvatar variant={emptyAvatarVariant} alt={fullName} sx={sx} iconSize={emptyAvatarIconSize} />
		)}
	</>
);

export default UserAvatar;
